import { Transaction, TransactionFeeType } from '__generated__/GQL';

import { formatAmount } from './formatAmount';
import formatPercent from './formatPercent';

type SupportedLanguages = 'en' | 'fr';

// Set it statically for now
const currency = 'EUR';

interface FeePricing {
  fixed: number;
  variable: number;
}

type Fees = Record<Transaction['feeType'], FeePricing>;

export const FEES: Fees = {
  ACCOUNT_IRREGULAR_USE: {
    fixed: 150,
    variable: 0,
  },
  ADDITIONAL_TRANSFER: {
    fixed: 0.4,
    variable: 0,
  },
  CARD_ATM_EURO: {
    fixed: 1,
    variable: 0,
  },
  CARD_ATM_NON_EURO: {
    fixed: 1,
    variable: 0.019,
  },
  CARD_PAYIN_EURO: {
    fixed: 0.2,
    variable: 0.012,
  },
  CARD_PAYIN_NON_EU: {
    fixed: 0.2,
    variable: 0.027,
  },
  CARD_PAYIN_NON_EURO: {
    fixed: 0.2,
    variable: 0.027,
  },
  CARD_PAYMENT_DISPUTE: {
    fixed: 20,
    variable: 0,
  },
  CARD_PAYMENT_IRREGULARITY: {
    fixed: 10,
    variable: 0,
  },
  CARD_PAYOUT_NON_EU: {
    fixed: 1.0,
    variable: 0.019,
  },
  CARD_PAYOUT_NON_EURO: {
    fixed: 1.0,
    variable: 0.019,
  },
  CARD_REPLACEMENT_BASIC: {
    fixed: 6,
    variable: 0,
  },
  CARD_REPLACEMENT_PREMIUM: {
    fixed: 10,
    variable: 0,
  },
  CASH_DEPOSIT: {
    fixed: 0,
    variable: 0.04,
  },
  CHECK: {
    fixed: 2,
    variable: 0,
  },
  CHECK_INVALID: {
    fixed: 5,
    variable: 0,
  },
  CHECK_REFUSED: {
    fixed: 25,
    variable: 0,
  },
  DIRECT_DEBIT_CANCELLATION: {
    fixed: 10,
    variable: 0,
  },
  FREE: {
    fixed: 0,
    variable: 0,
  },
  SWIFT_TRANSFER_PAYIN: {
    fixed: 5,
    variable: 0,
  },
};

export const getFixedFeeForType = (
  feeType: TransactionFeeType,
  lang?: SupportedLanguages,
): string =>
  formatAmount({
    currency,
    lang,
    type: 'payout',
    value: FEES[feeType].fixed,
  });

export const getVariableFeeForType = (feeType: TransactionFeeType): string =>
  formatPercent(FEES[feeType].variable);

export const getFeesForType = (
  feeType: TransactionFeeType,
  lang?: SupportedLanguages,
): string => {
  const result = [];
  if (FEES[feeType].fixed > 0) {
    result.push(getFixedFeeForType(feeType, lang));
  }
  if (FEES[feeType].variable > 0) {
    result.push(getVariableFeeForType(feeType));
  }
  return result.join(' + ');
};
